import configureStore from './configureStore';

/**
 * Create a store inside this file. Then import this store anywhere it is required
 * Avoid importing this file if not required. Always try to use connect method etc to get store
 */
const store = configureStore();

// E2E bridge: expose the store on window so integration tests can read state / dispatch
// actions. Env-gated — no-op unless REACT_APP_E2E_TESTING=true; production is unchanged.
if (process.env.REACT_APP_E2E_TESTING === 'true') {
  // eslint-disable-next-line no-underscore-dangle
  (window as any).__REDUX_STORE__ = store;
}

export default store;
